import React from "react";
import { RouteComponentProps } from "@reach/router";
import ProfileInfo from "./ProfileInfo";
import AccountInfo from "./AccountInfo";
import { TeacherCreationContext } from "context/TeacherCreation";
import SuccessInfo from "./SuccessInfo";
import Header from "ui/Header/SignupTeacher";
import axios from "axios";
import { Flow, Overview, Main, TabsWapper } from "pages/Auth/style";


interface TabProps {
  value: number;
  index: number;
  children?: React.ReactNode;

}

const Tab = ({ index, value, children }: TabProps) => {
  return (
    <>
      {
        value === index && (
          <>
            { children}
          </>
        )
      }
    </>
  )
}

const steps = [
  {
    label: 'Informations',
    index: 0
  },
  {
    label: 'Compte',
    index: 1
  },
]

const Auth: React.FC<RouteComponentProps> = () => {
  const { tabValue } = React.useContext(TeacherCreationContext);

  const [data, setData] = React.useState(null);

  React.useEffect(() => {
    axios('/api/v1/tutoring/page-text/4')
      .then(res => {
        setData(res.data)
      })
  }, []);



  return (
    <Main>
      <div className="row">
        <Flow className="col-md-8">
          <Header steps={steps} current={tabValue} />
          <TabsWapper className="col-md-9 mx-auto">
            <Tab value={tabValue} index={0}>
              <ProfileInfo />
            </Tab>
            <Tab value={tabValue} index={1}>
              <AccountInfo />
            </Tab>
            <Tab value={tabValue} index={2}>
              <SuccessInfo />
            </Tab>
          </TabsWapper>
        </Flow>
        <Overview className="col-md-4">
          <div dangerouslySetInnerHTML={{ __html: data?.presentation }}></div>
          <a href="/soutien-scolaire/famille" className="btn btn-primary">En savoir plus</a>
        </Overview>
      </div>
    </Main>
  )
}

export default Auth;